module.exports = __webpack_public_path__ + "static/media/madame-mimi-logo-gold.b2569029.png";